jQuery(function(){

    if(jQuery('body').find('.button_logic').length > 0){
        jQuery('body').find('.button_logic button[type="submit"]').attr('disabled', true);
        jQuery('.save-change-alert').addClass("hidden");

        function addFields(obj) {
            jQuery('body').find(".button_logic").find('input, textarea, select').each(function(index) {
                var identifier = jQuery(this).attr('name')+"_"+index;
                if(jQuery(this).attr('name') != '_token'){
                    var value = jQuery(this).val();
                    if(jQuery(this).attr('type') == "checkbox" || jQuery(this).attr('type') == "radio"){
                        if(jQuery(this).prop("checked") == true){
                            obj[identifier] = "checked";
                        } else {
                            obj[identifier] = "unchecked";
                        }
                    } else {
                        obj[identifier] = value;
                    }
                }
            });
            return obj;
        }

        function doTitle() {
            if(JSON.stringify(window.before_changes) !== JSON.stringify(window.after_changes)){
                if(jQuery('body').find('.save-changes-message').length){
                    jQuery('body').find('.save-changes-message').text("Changes made, Please save the changes.");
                }
                jQuery('.save-change-alert').removeClass("hidden");
            } else {
                if(jQuery('body').find('.save-changes-message').length){
                    jQuery('body').find('.save-changes-message').text("");
                }
                jQuery('.save-change-alert').addClass("hidden");
            }
        }

        function doTheButtons(){
            window.after_changes = addFields({});
            if(JSON.stringify(window.before_changes) !== JSON.stringify(window.after_changes)){
                jQuery('.button_logic').find('button[type="submit"]').removeAttr('disabled');
            } else {
                jQuery('.button_logic').find('button[type="submit"]').attr('disabled', true);
            }
            doTitle();
        }

        setTimeout(() => {
            window.before_changes = addFields({});
            window.after_changes = addFields({});

            // init the buttons here to avoid
            // a race-condition and btn not showing the right state
            // this timeout is based on other timeouts in various files 
            doTheButtons();
        }, 200);

        jQuery('body').on('keyup', 'input, textarea', function () {
            doTheButtons();
        });

        jQuery('body').on('change', 'input, form', function () {
            doTheButtons();
        });

        jQuery('body').on('click, mouseenter, mouseleave', 'select', function () {
            doTheButtons();
        });

        jQuery('span.paste').click(function() {
            doTheButtons();
        });

        jQuery('.template-click').click(function() {
            doTheButtons();
        });

        jQuery('body').on('mouseenter, mouseleave, mouseover', 'button[type="submit"]', function () {
            doTheButtons();
        });

        jQuery('body').on('click', '.reset-default, .reset-default-positive, .feedback-tag-remove', function () {
            doTheButtons();
        });

        jQuery('body').on('click', '.feedback-tag-remove', function () {
            doTheButtons();
        });

        jQuery('body').on('click', '.select-all, .clear-all, a.delete, button, .checkbox-select-all, .checkbox-clear-all', function () {
            setTimeout(function() {
                doTheButtons();
            }, 500);
        });

        jQuery('body').on('click', '.email-row .remove', function () {
            doTheButtons();
        });

        jQuery('body').on('click', '.remove-link', function () {
            doTheButtons();
        });

        window.hastriggered = false;
    }
});
